import React from "react";

interface PremiumInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const PremiumInput: React.FC<PremiumInputProps> = ({
  type = "text",
  placeholder,
  label,
  className,
  ...props
}) => (
  <div className="mb-4 relative group text-left">
    <label className="block text-[10px] font-bold text-slate-500 mb-1.5 tracking-wider uppercase pl-1">
      {label}
    </label>
    <input
      type={type}
      placeholder={placeholder}
      className={`w-full max-w-full min-w-0 box-border h-[46px] bg-slate-50 border border-slate-200 text-slate-800 rounded-lg px-4 py-0 text-base font-medium focus:outline-none focus:border-rose-400 focus:bg-white focus:ring-4 focus:ring-rose-50 transition-all placeholder-slate-400 shadow-[inset_0_2px_4px_rgba(0,0,0,0.02)] ${
        type === "datetime-local" ? "appearance-none" : ""
      } ${className ?? ""}`}
      {...props}
    />
  </div>
);

export default PremiumInput;
